import axios from '@/plugins/axios'

// initial state
const state = {
    token: '',
    user: {},
    lastUsername: '',
}

// getters
const getters = {
    token: state => state.token,
    user: state => state.user,
    lastUsername: state => state.lastUsername,
}

// actions
const actions = {
    async login({ commit }, user) {
        let login = {
            email: user.email,
            password: user.password,
        }

        return new Promise((resolve, reject) => {
            axios
                .post('/auth/login', login)
                .then(res => {
                    const data = {
                        token: res.data.token,
                        user: res.data.user,
                        lastUsername: user.email,
                    }

                    commit('makeAuth', data)

                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            axios
                .post('/auth/logout')
                .then(() => {
                    commit('makeLogout')

                    resolve()
                })
                .catch(() => {
                    commit('makeLogout')

                    reject()
                })
        })
    },
    clear({ commit }) {
        commit('makeLogout')
    },
}

// mutations
const mutations = {
    makeAuth(state, data) {
        state.token = data.token
        state.user = data.user
        state.lastUsername = data.lastUsername
    },
    makeLogout(state) {
        state.token = ''
        state.user = {}
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
